import { Autocomplete, TextField } from "@mui/material";
import React from "react";
import { Controller } from "react-hook-form";

//======= Select component for select/option elements =======

//Important props : control, name, label, option, optionLabel, equalLable
//Validation function and systems prop : rules
//Utils props: defaultValue, autoComplete, innerFunction
// 1) rules gets object and thats the react hook form rules prop
// 2) control prop gets control in react hookform control
// 3) name prop is our key in out submit data object. so choose carefully
// 4) This select is more complicated values like objects. for sending an simple value like string or number use WBSelectSimple instead
// 5) option prop gets an array filled with datas.
// 6) optionLable gets a if statement for showing current label if avilable ((example : (option) => option.Name ? option.Name : "")) 
// 7) equalLable gets a if statement for showing selected label in list if avilable ((example : (option, value) => option.Name === value.Name)) 
// 8) you can also use innerFunction prop for using onchange event when value changes

export default function CustomSelect ({ control, rules, name, defaultValue, autoComplete, option, optionLable, label, innerFunction, equalLable, isRequired, handleValidation, errorText, innerInputProps, innerPlaceHolder,  ...rest }) {
    const noOptionsText = 'موردی یافت نشد'

    return(
        <>
            <Controller
                name={name}
                control={control}
                render={({ field: { onChange, value }, fieldState: { error } }) => {
                    const initialValue = defaultValue || null;

                    return (
                        <Autocomplete
                            autoComplete={autoComplete || false}
                            noOptionsText={noOptionsText}
                            options={option}
                            getOptionLabel={optionLable}
                            isOptionEqualToValue={equalLable}
                            value={value || initialValue}
                            onChange={(event, value) => {
                                onChange(value)
                                if(innerFunction) {
                                    innerFunction(event, value)
                                }
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label={label}
                                    error={!!error}
                                    helperText={error ? error.message : null}
                                    placeholder={innerPlaceHolder}
                                    InputProps={{
                                        ...params.InputProps,
                                        ...innerInputProps
                                    }}
                                />
                            )}
                            {...rest}
                        />
                    )
                }}
                rules={{
                    required: isRequired ? (errorText ? errorText : "وارد کردن این فیلد اجباری است.") : null,
                    validation: handleValidation ? handleValidation() : null
                }}
            />
        </>
    )
}